import { REPORT_TYPES, ReportType } from "../reports-page-types/report-type";

export const REPORTS_WITH_JOBS_TABLE = new Set<ReportType>([
    REPORT_TYPES.COMMITMENT_USAGE,
    REPORT_TYPES.UNCHARGED_USAGE,
    REPORT_TYPES.PRODUCTS_USAGE,
] as const);
